import {
    VerticalTimeline,
    VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

function TimeLineElement(props: any) {
    return (
        <VerticalTimelineElement
            className='vertical-timeline-element--work'
            contentStyle={{ background: 'rgba(255, 255, 255, 0.14)' }}
            contentArrowStyle={{
                borderRight: '7px solid  rgba(255, 255, 255, 0.14)',
            }}
            date={props.Date}
            iconStyle={{
                background: 'rgba(255, 255, 255, 0.14)',
                color: '#fff',
                alignContent: 'center',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyItems: 'center',
            }}
            icon={
                props.Icon && (
                    <img className='timeline-icon' src={props.Icon} alt='img' />
                )
            }
        >
            <h3 className='vertical-timeline-element-title text'>{props.Title}</h3>
            <h4 className='vertical-timeline-element-subtitle'>
                {props.SubTitle}
            </h4>
            <p>{props.Description}</p>
            {props.Button && (
                <h6
                    className='mt-2 p-2 text custom-button'
                    style={{
                        width: 'fit-content',
                        textAlign: 'center',
						float: 'right',
                    }}
                    onClick={() => {
                        window.open(props.Button.Link, '_blank');
                    }}
                >
                    {props.Button.Text}
                </h6>
            )}
        </VerticalTimelineElement>
    );
}

export default function TimeLine({events}: any) {
    return (
        <VerticalTimeline className='text' lineColor={'rgb(65, 65, 65)'}>
            {events.map((event: any) => {
                return (
                    <TimeLineElement
                        key={event.Title}
                        Date={event.Date}
                        Title={event.Title}
                        Description={event.Description}
                        Icon={event.Icon}
                        Button={event.Button}
                    />
                );
            })}
        </VerticalTimeline>
    );
}
